module.exports = __webpack_public_path__ + "img/logo-light.2c736d4b.svg";